<template>
  <el-row>
    <el-card shadow="never">
      <baidu-map ref="allmap" class="map-view" :zoom="zoom" :center="center">
        <bm-control>
          <button v-if="showCircleBtn" @click="drawCircle">{{showCircleName}}</button>
          <button v-if="showPolygonBtn" @click="drawPolygon">{{showPolygonName}}</button>
        </bm-control>
        <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-marker :position="center" :dragging="true"></bm-marker>
        <bm-circle
          :center="circlePath.center"
          :radius="circlePath.radius"
          stroke-color="blue"
          :stroke-opacity="0.5"
          :stroke-weight="2"
          @lineupdate="updateCirclePath"
          :editing="circleEditing"
        ></bm-circle>
        <bm-polygon
          :path="polygonPath"
          stroke-color="blue"
          :stroke-opacity="0.5"
          :stroke-weight="2"
          :editing="polygonEditing"
          @lineupdate="updatePolygonPath"
        />
      </baidu-map>
    </el-card>
  </el-row>
</template>

<script>
export default {
  props: {
    zoom: {
      type: Number,
      default: 16,
    },
    center: {
      type: Object,
      default: { lng: 116.404, lat: 39.915 },
    },
    circlePath: {
      type: Object,
      default: {
        center: {
          lng: 116.404,
          lat: 39.915,
        },
        radius: 500,
      },
    },
    polygonPath: {
      type: Array,
      default: [
        { lng: 116.412732, lat: 39.911707 },
        { lng: 116.39455, lat: 39.910932 },
        { lng: 116.403461, lat: 39.921336 },
      ],
    },
  },
  data() {
    return {
      circleEditing: false,
      showCircleName: "绘制圆形",
      showCircleBtn: true,
      polygonEditing: false,
      showPolygonName: "绘制多边形",
      showPolygonBtn: true,
    };
  },
  methods: {
    drawCircle() {
      this.circleEditing = !this.circleEditing;
      this.showPolygonBtn = this.circleEditing === false;
      this.showCircleName = this.circleEditing ? "停止绘图" : "绘制圆形";
    },
    drawPolygon() {
      this.polygonEditing = !this.polygonEditing;
      this.showCircleBtn = this.polygonEditing === false;
      this.showPolygonName = this.polygonEditing ? "停止绘图" : "绘制多边形";
    },
    updateCirclePath(e) {
      this.circlePath.center = e.target.getCenter();
      this.circlePath.radius = e.target.getRadius();
    },
    updatePolygonPath(e) {
      this.polygonPath = e.target.getPath();
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
  },
};
</script>
<style scoped>
.map-view {
  width: 100%;
  height: 500px;
}
button {
  margin: 10px;
  padding: 10px;
  box-shadow: 2px 2px 2px #888;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.5);
}

button:active {
  outline: none;
  border: 1px solid blue;
  background: blue;
  color: #fff;
}

button:focus {
  outline: none;
  border: 1px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/baiduMap.vue